import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const PageUnderMaintenance = ({ text = 'Website Maintenance' }) => (
  <div className='flex items-center justify-center h-full'>
    <Box className='py-4 px-6 flex flex-col items-center justify-center'>
      <FontAwesomeIcon icon={['far', 'helmet-safety']} className='text-muted text-9xl text-center' />
      <Typography align='center' variant='inherit' className='text-muted uppercase text-6xl'>Sorry!</Typography> 
      <Typography align='center' variant='inherit' className='text-muted uppercase text-2xl'>{text}</Typography> 
    </Box>
  </div>
)
export default  PageUnderMaintenance
